module.exports = __webpack_public_path__ + "img/my-verse-home.2882272d.png";